import { CommonService } from 'src/app/services/common/common.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { Result } from 'src/app/model/result';
import { AppService } from 'src/app/services/app/app.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
export interface UserData{
  department_list:any[];
  department_data:any[];
  employee:any[];
  manager:any[];
}

@Component({
  selector: 'app-add-useful-document',
  templateUrl: './add-useful-document.component.html',
  styleUrls: ['./add-useful-document.component.scss']
})
export class AddUsefulDocumentComponent {
  public userType:string="department";
  public usefulDoc!:FormGroup;
  public isFileAvailable:boolean=true;
  public departmentArr:any[]=[]
  public empArr:any[]=[]
  public managerArr:any[]=[]
  public userData!:UserData;
  dropdownSettings: IDropdownSettings = {};
  dropdownSettingsEmp: IDropdownSettings = {};
  dropdownSettingsMan: IDropdownSettings = {};
  constructor(private commonService:CommonService,private fb:FormBuilder,private appService:AppService,private userManagementService:UserManagementService,
    private docService:DocumentService,private dialogRef:MatDialogRef<AddUsefulDocumentComponent>,
    private spinner:NgxSpinnerService,private staffSurveyService:StaffSurveyService){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.usefulDoc=this.fb.group({
      title:['',Validators.required],
      all_user:[''],
      department_id:[''],
      manager_id:[''],
      employee_id:['']
    })
    this.getList()
 
  }
  setDropDownArr(){
    this.dropdownSettings = {
      idField: 'd_i',
      textField: 'dep',
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsEmp = {
      idField: 'em_i',
      textField: 'name',
      "allowSearchFilter": true
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsMan = {
      idField: 'ma_i',
      textField: 'name',
      "allowSearchFilter": true
      // below setting will help to enable search filter in multi select dropdown
    };
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError( this.usefulDoc,controlName, validationType);
  }
  public files:File[]=[]
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  onCancel(){
    this.dialogRef.close()
  }
  getList(){
    this.spinner.show();
    this.docService.getAllUserListing().subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.userData = success.data;
          this.userData.employee.map(
            (item) =>
              (item["name"] = item["f_n"] + " " + item["l_n"])
          );
          this.userData.manager.map(
            (item) =>
              (item["name"] = item["f_n"] + " " + item["l_n"])
          );
          this.spinner.hide();
          this.setDropDownArr();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onUserType(value:string){
    this.userType=value
  }
  onSave(){
    if(this.usefulDoc.invalid){
      this.usefulDoc.markAllAsTouched()
    }
    else{
      let formData=new FormData()
      formData.append('title',this.usefulDoc.value.title)
      formData.append('useful_document',this.files[0])
     
      if(this.usefulDoc.value.all_user!==true){
        formData.append('all_user','false')
        if(this.userType=='manager'){
          formData.append('department_id','[]')
          formData.append('employee_id','[]')        
          if(this.usefulDoc.value.manager_id.length==this.userData.manager.length){
            formData.append('manager_id','all')
          } 
          else{
            let newManId:any[]=[];
            for(let i=0;i<this.usefulDoc.value.manager_id.length;i++){
              newManId.push(this.usefulDoc.value.manager_id[i].ma_i)
            }
            formData.append('manager_id',JSON.stringify(newManId))
          }
        }
        if(this.userType=='employee'){
          formData.append('department_id','[]')
          formData.append('manager_id','[]')         
          if(this.usefulDoc.value.employee_id.length==this.userData.employee.length){
            formData.append('employee_id','all')
          } 
          else{
            let newEmpId:any[]=[];
            for(let i=0;i<this.usefulDoc.value.employee_id.length;i++){
              newEmpId.push(this.usefulDoc.value.employee_id[i].em_i)
            }
            formData.append('employee_id',JSON.stringify(newEmpId))
          }
        }
        if(this.userType=='department'){
          formData.append('employee_id','[]')
          formData.append('manager_id','[]')
          let newDepId:any[]=[];
          for(let i=0;i<this.usefulDoc.value.department_id.length;i++){
            newDepId.push(this.usefulDoc.value.department_id[i].d_i)
          }
          if(this.usefulDoc.value.department_id.length==this.userData.department_list.length){
            formData.append('department_id','all')
          } 
          else{
            formData.append('department_id',JSON.stringify(newDepId))
          }
        }
      }
      else{
        formData.append('all_user',JSON.stringify(this.usefulDoc.value.all_user))
        formData.append('department_id','[]')
        formData.append('employee_id','[]')
        formData.append('manager_id','[]')
      }
      this.spinner.show()
      this.docService.addUsefulDoc(formData).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide();
            this.appService.showToastMessage("success", success.msg);
            this.dialogRef.close({ data_added: true });
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  setValue(){

  }
  getEmployee(){}
  getManager(){}
 
}
